import { render, staticRenderFns } from "./StockMovementReasonSidebar.vue?vue&type=template&id=227d0b83&"
import script from "./StockMovementReasonSidebar.vue?vue&type=script&lang=js&"
export * from "./StockMovementReasonSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('227d0b83')) {
      api.createRecord('227d0b83', component.options)
    } else {
      api.reload('227d0b83', component.options)
    }
    module.hot.accept("./StockMovementReasonSidebar.vue?vue&type=template&id=227d0b83&", function () {
      api.rerender('227d0b83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/settings/stock/StockMovementReasonSidebar.vue"
export default component.exports